import { defineComponent } from "vue";

export const ColumnGroup = defineComponent({
  name: "LISADataTableColumnGroupDeclaration",
  inheritAttrs: false,
  setup: () => () => null,
});
